import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import moment from 'moment'
import 'video.js/dist/video-js.css'
import 'swiper/swiper-bundle.min.css'
import './utils/rem'
import './utils/vant'
import isModel from '@/utils/isModel'
import axios from 'axios'

// import share from '@/api/share.js'
import Swiper2, { Navigation, Pagination, Autoplay, EffectCoverflow, EffectFlip } from 'swiper';
Swiper2.use([Autoplay, Navigation, Pagination, EffectCoverflow, EffectFlip])
Vue.use(VueAwesomeSwiper)
// Vue.mixin(share)
Vue.config.productionTip = false
Vue.prototype.$moment = moment
Vue.prototype.$isModel = isModel
Vue.prototype.$axios = axios
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
